<template>
	<inertia-head title="Win a Coffee Session with Bro. Bo Sanchez!"/>
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Thank you
					</h1>
					
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				
				<div class="block block-rounded">
					<div class="block-content block-content-full text-center">
						<h3>Please check your email for the QR Code we just sent you!</h3>

						<div v-if="has_quiz" class="mt-4 border-top pt-5">
							<h4>Total Score Financial Fitness Level Meaning</h4>
							<h2>{{total_quiz}}</h2>
							<p class="fw-bold">Your Total Score</p>
							<div class="my-3">
								<p>{{display_explanation}}</p>
							</div>
						</div>
						<div class="mt-4">
							<inertia-link href="/c/feastcon" class="btn btn-info">Go Back</inertia-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import Stripe from '../Shared/Components/Stripe';

	export default{
		layout: GuestLayout,
		props:{
			has_quiz 			: Boolean,
			total_quiz 			: Number,
			display_explanation : String,
			flash 				: Object,
			book 				: Object,
		},
		components: {
			Stripe,
		},
		setup(props){

			
			return {
			
			}

		}
	}
</script>